import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SmsService } from 'src/app/services/sms.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-view-sent-sms',
  templateUrl: './view-sent-sms.component.html',
  styleUrls: ['./view-sent-sms.component.css']
})
export class ViewSentSmsComponent implements OnInit {


  userId:any
  smses:any[]
  replies:any[]
  baseURL=environment.url

  constructor(
    private smsService:SmsService,
    private activatedRoute:ActivatedRoute,
    private snackbarService:SnackbarService) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(data => {
      if(data['userId']) {
        this.userId=data['userId']
        this.getUsersSentEmail()
      } else {
        this.getAllSentSms();
      }
    })
  }

  getAllSentSms() {
    this.smsService.getAllSentSms().subscribe((response:any) => {
      this.smses=response.data

      $(document).ready(function () { $('#example').DataTable(); });
    })
  }

  getUsersSentEmail() {
    this.smsService.getUsersSentEmails(this.userId).subscribe((response:any) => {
      this.replies=response.getMassMails
      $(document).ready(function () { $('#example').DataTable(); });
    })
  }

  showContent(content) {
    this.snackbarService.show(content,'')
  }

  currentGroupSmses:string[]
  showUsersContactNumbers(groupedData:any) {
    this.currentGroupSmses=groupedData.user_contact.map(element => `${element}`)
  }

  getStatus(status:any){
    if(status=="pending"){
      return "queued"
    }else{
      return status
    }
  }
  
  deleteSms(notificationArray:any) {
    const ids=Array.isArray(notificationArray) ? notificationArray : [notificationArray]
      this.snackbarService.alertWithConfirmations("Are you sure you want to delete this sms?").then(response => {
        if(!response.isConfirmed){
          return
        }
        this.smsService.deleteSms(ids).subscribe((response : any) =>{
          if(response.status==200){
            this.getAllSentSms()
            this.snackbarService.showSuccess(response.message||"Sms deleted successfully!")
          }
        
      })
    })
    
  }

}
